import { Location } from '../types/upgrade'

export const getLocation = (location: string) => {
  let locationToUse: string = Location.GB
  if (location in Location) {
    locationToUse = location
  }
  return locationToUse
}
